import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const PageBody = ({ className, children }) => {
  return <div className={classNames("tw-grow", className)}>{children}</div>;
};

PageBody.displayName = "PageBody";

PageBody.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default PageBody;
